import { Instagram, MessageCircle } from "lucide-react";
import BrandLogo from "@/components/BrandLogo";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#0A0A0B] mt-24" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-12 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <BrandLogo size="md" showSubtitle={false} />
          <p className="mt-4 text-sm text-gray-400 max-w-sm leading-relaxed">
            Rental PlayStation modern dengan sistem booking online dan turnamen komunitas gaming.
          </p>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-widest text-gray-500 mb-4">Navigasi</h4>
          <ul className="space-y-2 text-sm text-gray-300">
            <li>Beranda</li>
            <li>Booking Unit</li>
            <li>Event & Turnamen</li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-widest text-gray-500 mb-4">Terhubung</h4>
          <div className="flex gap-3">
            <a className="w-10 h-10 flex items-center justify-center border border-white/10 hover:border-[#00E5FF] hover:text-[#00E5FF] transition-colors" href="#">
              <Instagram size={18} />
            </a>
            <a className="w-10 h-10 flex items-center justify-center border border-white/10 hover:border-[#00E5FF] hover:text-[#00E5FF] transition-colors" href="#">
              <MessageCircle size={18} />
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/5 py-6 text-center text-xs text-gray-500 uppercase tracking-widest">
        © 2026 Rental.PS Zone — Level Up Your Game
      </div>
    </footer>
  );
}
